import {
    createContext,
    useContext
} from "react";
import type {
    InputGroupAddonVariant,
    InputGroupAddonAlign
} from "./components/addon/type";
import type {
    InputGroupContextType
} from "./type";

export type InputGroupAddonContextType = {
    variant: InputGroupAddonVariant;
    align: InputGroupAddonAlign;
};

export const InputGroupContext = createContext<InputGroupContextType | null>(null);

export const InputGroupAddonContext = createContext<InputGroupAddonContextType | null>(null);

export const useInputGroupContext = (): InputGroupContextType => {
    const context = useContext(InputGroupContext);

    if(!context) {
        throw new Error("InputGroup parts must be rendered inside an InputGroup.");
    }

    return context;
};

export const useInputGroupAddonContext = (): InputGroupAddonContextType | null => {
    return useContext(InputGroupAddonContext);
};
